import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IQuestion } from '../../../../interfaces/question.interface';

@Component({
  selector: 'app-choices-answer',
  templateUrl: './choices-answer.component.html',
  styleUrls: ['./choices-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChoicesAnswerComponent {
  @Input() question: IQuestion;
}
